import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  MenuItem,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
  FormControl,
  InputLabel,
  Select,
} from '@material-ui/core';

const corporateList = [
  'CORDLIFE SCIENCES INDIA PRIVATE LIMITED',
  'CORDLIFE SCIENCES INDIA PVT LTD',
  'CORE ENERGY SYSTEMS PRIVATE LIMITED',
  'CORMECHANICS PRIVATE LIMITED',
  'COROT SYSTEMS PRIVATE LIMITED',
  'CORPORATE ENTERPRISES',
  'CORPORATE WARRANTIES INDIA PRIVATE LIMITED',
  'CORPORATION BANK RETIRED OFFICERS ASSOCIATION',
  'CORSICA SOLUTIONS PRIVATE LIMITED',
  'MULTITECH CONCEPTS',
  'MUNJAL SHOWA LTD',
  'MUSIC BROADCAST LIMITED',
  'MUTHOOT PAPPACHAN CENTRE OF EXCELLENCE IN SPORTS',
];

const configTypes = [
  { value: '', label: '--- Select One ---' },
  { value: 'CHANGE_SI', label: 'Change SI' },
  { value: 'CHANGE_AGE', label: 'Change AGE' },
];

const AgeConfiguration = () => {
  const [corpCode, setCorpCode] = React.useState('TRACK');
  const [corporate, setCorporate] = React.useState('');
  const [configType, setConfigType] = React.useState('CHANGE_SI');

  const [rows, setRows] = React.useState([
    { slNo: 1, siAmount: 750000 },
    { slNo: 2, siAmount: 1000000 },
  ]);

  const [newSl, setNewSl] = React.useState('');
  const [newSi, setNewSi] = React.useState('');

  const addRow = () => {
    if (newSl === '' || newSi === '') return;
    setRows(prev => [...prev, { slNo: Number(newSl), siAmount: Number(newSi) }]);
    setNewSl('');
    setNewSi('');
  };

  const handleChange = event => {
    setCorporate(event.target.value);
  };

  const headerBlue = '#0ea5d9'; // close to screenshot
  return (
    <Box>
      {/* Title bar */}
      <Box component={Paper} p={2} mb={2} fontWeight="bold">
        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
          SI Age Configuration
        </Typography>
      </Box>

      {/* Form panel */}
      <Box
        style={{
          margin: '16px auto',
          maxWidth: 920,
          border: '2px solid #9ecfe3',
          borderRadius: 6,
          padding: 12,
        }}>
        <Grid container style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
          <Grid style={{ display: 'flex' }}>
            <Grid item xs={12} md={2} style={{ marginTop: '1.2rem' }}>
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                <span style={{ color: 'red' }}>*</span> Corporate :
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth variant="outlined" margin="dense" size="small">
                <Select value={corporate} onChange={handleChange} displayEmpty>
                  <MenuItem value="">Select Corporate</MenuItem>
                  {corporateList.map((name, idx) => (
                    <MenuItem key={idx} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid style={{ display: 'flex' }}>
            <Grid item xs={12} md={2} style={{ marginTop: '0.5rem' }}>
              <Typography variant="body2" style={{ fontWeight: 600 }}>
                <span style={{ color: 'red' }}>*</span> Config Type :
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                select
                size="small"
                variant="outlined"
                fullWidth
                value={configType}
                onChange={e => setConfigType(e.target.value)}
                InputProps={{ style: { height: 32 } }}>
                {configTypes.map(o => (
                  <MenuItem key={o.value} value={o.value}>
                    {o.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* Table with existing rows */}
      <Box style={{ maxWidth: 760, margin: '0 auto 12px' }}>
        <Table size="small" style={{ border: '1px solid #9ecfe3' }}>
          <TableHead>
            <TableRow>
              <TableCell
                style={{
                  background: headerBlue,
                  color: '#fff',
                  fontWeight: 700,
                  borderRight: '1px solid #fff',
                  textAlign: 'center',
                }}>
                Sl No
              </TableCell>
              <TableCell
                style={{
                  background: headerBlue,
                  color: '#fff',
                  fontWeight: 700,
                  textAlign: 'center',
                }}>
                SI Amount
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(r => (
              <TableRow key={`${r.slNo}-${r.siAmount}`}>
                <TableCell style={{ textAlign: 'center' }}>{r.slNo}</TableCell>
                <TableCell style={{ textAlign: 'center' }}>{r.siAmount.toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>

      {/* Add row section */}
      <Box style={{ maxWidth: 760, margin: '0 auto 16px' }}>
        <Table size="small" style={{ border: '1px solid #9ecfe3' }}>
          <TableHead>
            <TableRow>
              <TableCell
                style={{
                  background: headerBlue,
                  color: '#fff',
                  fontWeight: 700,
                  borderRight: '1px solid #fff',
                  textAlign: 'center',
                }}>
                Sl No
              </TableCell>
              <TableCell
                style={{
                  background: headerBlue,
                  color: '#fff',
                  fontWeight: 700,
                  textAlign: 'center',
                }}>
                SI Amount
              </TableCell>
              <TableCell
                style={{
                  background: headerBlue,
                  color: '#fff',
                  fontWeight: 700,
                  width: 90,
                  textAlign: 'center',
                }}>
                &nbsp;
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell style={{ textAlign: 'center', width: 160 }}>
                <TextField
                  type="number"
                  variant="outlined"
                  size="small"
                  value={newSl}
                  onChange={e => setNewSl(e.target.value === '' ? '' : Number(e.target.value))}
                  InputProps={{ style: { height: 28, padding: '0 8px' } }}
                />
              </TableCell>
              <TableCell style={{ textAlign: 'center' }}>
                <TextField
                  type="number"
                  variant="outlined"
                  size="small"
                  value={newSi}
                  onChange={e => setNewSi(e.target.value === '' ? '' : Number(e.target.value))}
                  InputProps={{ style: { height: 28, padding: '0 8px' } }}
                />
              </TableCell>
              <TableCell style={{ textAlign: 'center' }}>
                <Button
                  onClick={addRow}
                  disabled={newSl === '' || newSi === ''}
                  style={{
                    backgroundColor: headerBlue,
                    color: '#fff',
                    minHeight: 24,
                    padding: '2px 12px',
                    textTransform: 'none',
                    borderRadius: 12,
                    fontWeight: 700,
                  }}>
                  Add
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default AgeConfiguration;
